import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useState } from 'react';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
const FromDateModal = _ref => {
  let {
    title,
    onHide,
    show,
    onSubmit
  } = _ref;
  const [date, setSelectedDate] = useState(null);
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(DatePicker, {
      selected: date,
      onChange: setSelectedDate
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    title: title,
    renderBody: modalBody,
    onHide: onHide,
    onSubmit: () => {
      onSubmit(date);
    }
  });
};
export default FromDateModal;